import React, {FunctionComponent, useState, useEffect} from "react"
import {useModal} from "@murphy-frontend/web-core/contexts/ModalContext"
import {ModalConfiguration} from "@murphy-frontend/web-core/components/Modal"
import {HistoryDto, StartedEventFlowHistoryDto, TimeLineDto} from "@murphy-frontend/common/interfaces/IDroneEventsApi"
import {convertEventStatus} from "@murphy-frontend/common/utils"
import FilterTag from "@murphy-frontend/web-core/components/FilterTag"
import EventHistoryTable from "./EventHistoryTable"
import {useUserPreferences} from "../../../common/contexts/UserPreferencesContext"
import {getConvertedDateDayjs} from "@murphy-frontend/common/services/TimeService"
import dayjs from "dayjs"

interface StatusCard {
	status: string
	createdAt: string
	creator: string
	lastEdit?: Date
}
interface StatusCardProps {
	steps?: TimeLineDto[]
	history?: HistoryDto[]
	eventFlowHistory: StartedEventFlowHistoryDto[]
	longitude?: string
	latitude?: string
}

const StatusCard: FunctionComponent<StatusCardProps> = ({steps, history, eventFlowHistory, latitude, longitude}) => {
	const [statusCard, setStatusCard] = useState<StatusCard>()
	const [hisData, setHisData] = useState<HistoryDto[]>(history)
	const {timeZone, translations} = useUserPreferences()

	const {openModal, closeModal} = useModal()

	useEffect(() => {
		let card: StatusCard = {}
		if (history.length) {
			if (eventFlowHistory.length) {
				const sortedTime = [...history, ...eventFlowHistory].sort((a, b) => dayjs(b.Time).diff(dayjs(a.Time)))
				card.lastEdit = sortedTime[0].Time
			} else card.lastEdit = null

			card.createdAt = steps[0].time
			card.creator = steps[0].Username
			card.status = steps[steps.length - 1].status
			setStatusCard(card)
		}

		setHisData(history)
	}, [steps, history, eventFlowHistory])

	if (!steps.length || !statusCard || !history.length) return <></>

	let filterName = !convertEventStatus(statusCard.status) ? "Active" : "Closed"

	const onClickShowHistory = () => {
		const modalConf: ModalConfiguration = {
			body: (
				<EventHistoryTable
					history={hisData}
					timeZone={timeZone}
					eventFlowHistory={eventFlowHistory}
					translations={translations}
				/>
			),
			position: "center",
			buttonText: "Ok",
			hideButton: true
		}

		openModal(modalConf)
	}

	const showOnMapClicked = () => {
		window.open(`https://maps.google.com?q=${latitude},${longitude}`)
	}

	return (
		<div className='event-flow-status-card'>
			<div className='event-flow-status-row'>
				<div className='event-flow-status-col'>{translations["class-lang-modal-status"]}</div>
				<div className='event-flow-status-col'>
					<FilterTag status={convertEventStatus(statusCard.status)} filterName={filterName} />
				</div>
			</div>
			<div className='event-flow-status-row'>
				<div className='event-flow-status-col'>{translations.created}</div>
				<div className='event-flow-status-col'>
					{getConvertedDateDayjs(statusCard.createdAt, timeZone).format("DD MMM YYYY, HH:mm:ss")}
				</div>
			</div>
			<div className='event-flow-status-row'>
				<div className='event-flow-status-col'>{translations.creator}</div>
				<div className='event-flow-status-col'>{statusCard.creator}</div>
			</div>
			<div className='event-flow-status-row'>
				<div className='event-flow-status-col'>{translations.location}</div>
				{!!latitude ? (
					<div className='event-flow-status-col event-flow-maps' onClick={() => showOnMapClicked()}>
						{translations.googleMap || "Show map"}
					</div>
				) : (
					<div className='event-flow-status-col'>N/A</div>
				)}
			</div>
			<div className='event-flow-status-row'>
				<div className='event-flow-status-col'>{translations.lastEdit}</div>
				{!statusCard.lastEdit && <div className='event-flow-status-col'>N/A</div>}
				{statusCard.lastEdit && (
					<div className='event-flow-status-col'>
						{getConvertedDateDayjs(statusCard.lastEdit, timeZone).format("DD MMM YYYY, HH:mm:ss")}
					</div>
				)}
			</div>
			<div className='event-flow-status-row'>
				<div className='event-flow-status-col'></div>
				<div className='event-flow-status-col event-block-saved--table' onClick={() => onClickShowHistory()}>
					{translations.viewFullEditHistory}
				</div>
			</div>
		</div>
	)
}

export default StatusCard
